import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { updateUiAction } from 'actions/uiActions'

const projectTitleUpdated = (value, callback, updateUiAction) => {
  callback({ title: value })
  updateUiAction({ titleChanged: true })
}

class ProjectTitle extends React.Component {
  state = { 
    glow: false
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.title !== this.props.title) {
      this.setState({ glow: true })
      clearTimeout(this.timeout)
      this.timeout = setTimeout(
        _ => this.setState({ glow: false }),
        1600
      )
    }
  }

  render() {
    const { state: { glow }, props: { title, callback, classes, updateUiAction, titleChanged } } = this
    return (
      <input
        className={`${classes.projectTitleEdit} ${glow && !titleChanged ? classes.inputGlow : ''}`}
        type='text'
        onChange={({ target: { value } }) => projectTitleUpdated(value, callback, updateUiAction)}
        value={title || ''}
      />
    )
  }
}

export default connect(null, { updateUiAction })(injectSheet(style)(ProjectTitle))



// WEBPACK FOOTER //
// ./src/components/TopBar/ProjectTitle/index.js